export var HookTypes;
(function (HookTypes) {
    HookTypes["onMount"] = "onMount";
    HookTypes["onMounted"] = "onMounted";
    HookTypes["onUnmount"] = "onUnmount";
    HookTypes["onUnmounted"] = "onUnmounted";
    HookTypes["onRouteChangeEnd"] = "onRouteChangeEnd";
    HookTypes["onRouteChangeStart"] = "onRouteChangeStart";
    HookTypes["onRouteChangeError"] = "onRouteChangeError";
})(HookTypes || (HookTypes = {}));
//# sourceMappingURL=types.js.map